import { getMathEquations } from './getMathEquations';
import { hasChemicalEquation } from './hasChemicalEquation';

interface CountMathEquationsParams {
  question: { questionText: string; explanation: string };
  answers?: Array<{ text: string }>;
}

/**
 * Converts the Question and Answers parameters to an array to make it easier to process
 * @param answers
 * @param question
 */
function convertQuestionAnswersToStringArray({
  answers,
  question,
}: CountMathEquationsParams) {
  if (question == null) {
    return [];
  }

  const { questionText, explanation } = question;
  return [
    questionText,
    explanation,
    ...(answers ?? []).map((answer) => answer.text),
  ].filter(Boolean);
}

/**
 * counts the number of math equations in a question
 * @param params
 */
export function countMathEquations(params: CountMathEquationsParams) {
  const htmlStrings = convertQuestionAnswersToStringArray(params);

  if (htmlStrings.length === 0) {
    return {
      formulaCount: 0,
      chemicalCount: 0,
    };
  }
  const formulas = htmlStrings
    .map(getMathEquations)
    .reduce(
      (accumulator, current) => [
        ...accumulator,
        ...(current ?? []).filter(Boolean),
      ],
      []
    );

  const chemicalEquationCount = formulas.reduce((total, latex) => {
    if (hasChemicalEquation(latex)) {
      return total + 1;
    }
    return total;
  }, 0);

  return {
    formulaCount: formulas.length,
    chemicalCount: chemicalEquationCount,
  };
}
